import { COMMON } from './common';

const STRINGS = {
	COMMON,
};

export default STRINGS;
